<template>
  <!-- begin::gachi-header -->
  <header
    class="header"
    :class="{ 'is-active': isHeaderOver }"
    @mouseover.prevent="headerOver(true)"
    @mouseout.prevent="headerOver(false)"
  >
    <!--<div class="header-banner is-visible">-->
    <div
      v-if="!isConnect"
      class="header-banner"
      :class="{ 'is-visible': msgCount > 0 }"
    >
      <div class="header-component">
        <!--          <a href="" class="banner-link btn-icontext" title="확인하러 가기">-->
        <router-link
          to="/mypage/connect"
          class="banner-link btn-icontext"
          title="확인하러 가기"
        >
          <i class="icon-banner-noti"></i>
          <span class="banner-text">{{ msgCount }}건의 알람이 있어요 !</span>
        </router-link>
        <!--          </a>-->
        <button
          type="button"
          class="btn-icon"
          title="팝업 닫기"
          @click="closeTopPopup"
        >
          <i class="icon-banner-close"></i>
        </button>
      </div>
    </div>
    <div class="header-gnb">
      <div class="header-component">
        <div class="header-logo eng">
          <router-link to="/en" class="logo-link">
            <i class="logo"></i>
            <span class="sr-only">KOREA SHOPPING FESTA 동행축제</span>
          </router-link>
        </div>
        <div class="header-menu" id="gachi-header">
          <ul class="header-menu-list eng">
            <li
              v-for="(menu, idx) in menus"
              class="header-menu-item"
              :key="idx"
              :class="{ 'is-active': menu.isActive }"
              @mouseover.prevent="menuVisible(idx, $event)"
              @mouseleave.prevent="menuVisible(idx, $event)"
            >
              <router-link
                v-if="menu.path"
                :to="menu.path"
                class="header-menu-link"
                target=""
              >
                <span class="header-menu-text" v-html="menu.title"></span>
              </router-link>
              <a v-else href="javascript:" class="header-menu-link">
                <span class="header-menu-text" v-html="menu.title"></span>
              </a>
              <template v-if="menu.children && menu.children.length > 0">
                <div v-if="menu.isSubActive" class="header-sub">
                  <ul
                    class="header-sub-list header-sub-community"
                    @mouseleave.prevent="menuHidden(idx)"
                  >
                    <li
                      v-for="(child, i) in menu.children"
                      class="header-sub-item"
                      :key="`sub-${idx}-${i}`"
                    >
                      <a
                        v-if="child.isTargetBlank"
                        :href="child.path"
                        class="header-sub-link"
                        target="_blank"
                      >
                        <div class="header-sub-cont">
                          <span class="header-sub-text">{{ child.title }}</span>
                          <span
                            v-if="child.isTargetBlank"
                            class="header-sub-arrow"
                          >
                            <img
                              src="../../../assets/img/common/link-arrow.svg"
                            />
                          </span>
                        </div>
                      </a>
                      <router-link
                        v-else
                        :to="child.path"
                        class="header-sub-link"
                        @mouseup.native="clickSameRoute(child.path)"
                      >
                        <div class="header-sub-cont">
                          <span class="header-sub-text">{{ child.title }}</span>
                          <span
                            v-if="child.isTargetBlank"
                            class="header-sub-arrow"
                          >
                            <img
                              src="../../../assets/img/common/link-arrow.svg"
                            />
                          </span>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </template>
            </li>
          </ul>
        </div>
        <div class="header-util">
          <ul class="header-util-list">
            <!-- <li v-if="isAuth" class="header-util-item hidden-tablet">
							<router-link to="/ko/mypage" class="header-util-link">
								<span>마이페이지</span>
							</router-link>
						</li>

						<li class="header-util-item hidden-tablet">
							<template v-if="isAuth">
								<button type="button" class="button is-rounded is-gray" @click="logout">
									<i class="icon"><icon name="icon-header-logout" /></i>
									<span class="text">로그아웃</span>
								</button>
							</template>
							<template v-else>
								<router-link to="/login" class="button is-rounded is-gray">
									<i class="icon"><icon name="icon-header-user" /></i>
									<span class="text">로그인</span>
								</router-link>
							</template>
						</li> -->
            <li class="header-util-item">
              <router-link to="/" class="header-util-link__lang">
                <i
                  ><img src="../../../assets/img/common/icon-header-lang.svg"
                /></i>
                <strong>KOR</strong>
              </router-link>
            </li>
            <!-- <li class="header-util-item hidden-tablet">
              <a
                href="https://portal.valuebuy.kr"
                target="_blank"
                title="새창열림"
                class="header-util-link"
              >
                <i class="ico ico-onfan"></i>
                <span class="sr-only">온판</span>
              </a>
            </li> -->
            <li
              class="header-util-item header-util-aside"
              data-toggle="aside-open"
            >
              <button type="button" class="header-util-link" @click="asideOpen">
                <i class="icon-util-menu"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="header-sub-overlay"
      :class="{ 'is-active': isSubHeaderOver }"
      @mouseleave.prevent="menuLeave"
    ></div>
    <floating-buttons />
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import {
  MUT_REMOVE_MESSAGE_COUNT,
  MUT_SET_RETURN_ROUTE,
  MUT_SHOW_CONFIRM,
} from "../../../store/_mut_consts";
import { ACT_REMOVE_AUTH_TOKEN } from "../../../store/_act_consts";
import Icon from "@/components/common/Icon";
import menus from "../../../assets/js/eng_menus";

import FloatingButtons from "@/components/common/FloatingButtons";

export default {
  name: "MainHeader",
  components: { Icon, FloatingButtons },
  props: {
    openAsideMenu: Function, // 모바일 aside 메뉴 open
  },
  computed: {
    ...mapGetters("auth", ["isAuth", "session"]),
    ...mapGetters("common", ["msgCount", "headerSticky", "isMobile", "campn"]),

    isConnect() {
      return this.$route.path === "/mypage/connect";
    },
    isActiveMenu: {
      get: function () {
        for (let i = 0; i < this.menus.length; i++) {
          if (
            this.menus[i].isActive &&
            this.menus[i].children &&
            this.menus[i].children.length > 0
          ) {
            //if (this.menus[i].isActive) {
            return true;
          }
        }
        return false;
      },
      set: function (newVal) {
        return newVal;
      },
    },
    isMenuActive: {
      get: function () {
        for (let i = 0; i < this.menus.length; i++) {
          if (this.menus[i].children && this.menus[i].children.length > 0) {
            for (let j = 0; j < this.menus[i].children.length; j++) {
              const path = this.menus[i].children[j].path;
              if (path.includes(this.$route.path)) {
                return true;
              }
            }
          } else {
            const path = this.menus[i].path;
            if (path.includes(this.$route.path)) {
              return true;
            }
          }
        }
        return false;
      },
    },
  },
  data: () => ({
    menus: menus,
    mainPath: false,
    marketUrl: `${process.env.VUE_APP_GACHI_MALL_HOST}`,
    isHeaderOver: false,
    isSubHeaderOver: false,
    isLogoLinkShow: false,
    fanfan_url:
      `${process.env.VUE_APP_FANFAN_SSO_AGENT_HOST}` +
      "/RequestConnect.jsp?RelayState=https://fanfandaero.kr/portal/main.do",
    gachiAgentUrl: `${process.env.VUE_APP_GACHI_SSO_AGENT_HOST}`,
  }),
  created() {
    this.activeMenus();

    // const tagetDate = new Date('2024-01-01 00:00:00');
    // //const tagetDate = new Date('2023-12-21');
    // //console.log('tagetDate : ', tagetDate);
    // const nowDate = new Date();
    // //console.log('nowDate : ', nowDate);
    // if(nowDate < tagetDate){	//몰 링크를 2023-12-31 까지만 노출
    // 	this.isLogoLinkShow = true;
    // }
  },
  watch: {
    $route: function () {
      this.activeMenus();
    },
  },
  methods: {
    logout() {
      this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, {
        title: `로그아웃을 하시겠습니까?`,
        showCancelButton: true,
        yesfunc: () => {
          if (this.session.userPattnCd === "400") {
            this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
            window.location = this.gachiAgentUrl + "/Logout.jsp";
          } else {
            this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
            if (
              this.$route.name === "MyPage" ||
              this.$route.name === "MyPage2"
            ) {
              //마이페이지(신규) 에서도 로그아웃 시 로그인 화면으로 이동 추가
              this.$store.commit(
                `common/${MUT_SET_RETURN_ROUTE}`,
                this.$route.path
              );
              this.$router.push({ name: "Login" });
            } else {
              //console.log(this.$route.fullPath);
              this.$router.go(this.$router.currentRoute);
              //this.$router.go(0);
            }
          }
        },
      });
    },
    certification() {
      if (
        !window.location.hostname.includes("portal") &&
        !window.location.hostname.includes("localhost")
      ) {
        window.location = "https://portal.valuebuy.kr/join";
      } else {
        this.$router.push({ name: "Join" });
      }
    },
    closeTopPopup() {
      this.$store.commit(`common/${MUT_REMOVE_MESSAGE_COUNT}`);
    },
    // showSearch() {
    // 	this.$store.commit(`common/${MUT_SHOW_SEARCH_MODAL}`);
    // },
    menuVisible(idx, e) {
      // console.log(e.relatedTarget)
      // console.log(e.target)
      // console.log('-------------')
      // if(e.relatedTarget){
      //   return;
      // }
      // console.log(e.type);

      // 단일 active
      // for (let i = 0; i < this.menus.length; i++) {
      // 	this.menus[i].isActive = false;
      // 	this.isSubHeaderOver = false;
      // }

      let routePath = this.$route.path;
      // playground 와 playground2 가 있어 playground에 ? 추가
      if (routePath == "/playground") {
        routePath = routePath + "?";
      }

      let routeActive = false;
      if (routePath !== "/" && routePath !== "/en") {
        for (let i = 0; i < this.menus.length; i++) {
          if (this.menus[i].children && this.menus[i].children.length > 0) {
            let childPathActive = false;
            for (let j = 0; j < this.menus[i].children.length; j++) {
              const path = this.menus[i].children[j].path;
              if (path.includes(routePath)) {
                childPathActive = true;
              }
            }
            if (childPathActive) {
              this.menus[i].isActive = true;
            } else {
              this.menus[i].isActive = false;
            }
          } else {
            const path = this.menus[i].path;
            if (path.includes(routePath)) {
              this.menus[i].isActive = true;
            } else {
              this.menus[i].isActive = false;
            }
          }

          if (i == idx) {
            routeActive = true;
          }
        }
      }

      if (e.type == "mouseleave") {
        if (!routeActive) {
          this.menus[idx].isActive = false;
        }

        if (this.menus[idx].children && this.menus[idx].children.length > 0) {
          this.menus[idx].isSubActive = false;
          this.isSubHeaderOver = false;
        }
      } else {
        this.menus[idx].isActive = true;
        if (this.menus[idx].children && this.menus[idx].children.length > 0) {
          this.menus[idx].isSubActive = true;
          this.isSubHeaderOver = true;
        }
      }
    },
    menuHidden(idx) {
      //this.isSubHeaderOver = false;
      // // for (let i = 0; i < this.menus.length; i++) {
      // // 	this.menus[i].isActive = false;
      // // }
      // let loutePath = this.$route.path;
      // // playground 와 playground2 가 있어 playground에 ? 추가
      // if(loutePath == '/playground'){
      // 	loutePath = loutePath + '?'
      // }
      // if(this.menus[idx].children && this.menus[idx].children.length > 0){
      // 	for (let j = 0; j < this.menus[idx].children.length; j++) {
      // 		const path = this.menus[idx].children[j].path;
      // 		if(path.includes(loutePath)){
      // 			this.menus[idx].isActive = true;
      // 			return;
      // 		}
      // 	}
      // } else {
      // 	const path = this.menus[idx].path;
      // 	if(path.includes(loutePath)){
      // 		this.menus[idx].isActive = true;
      // 		return;
      // 	}
      // }
      // this.menus[idx].isActive = false;
    },
    headerOver(bool) {
      this.isHeaderOver = bool;
      if (bool === false) {
        this.isActiveMenu = false;
      }
    },
    menuLeave(idx) {
      // let loutePath = this.$route.path;
      // // playground 와 playground2 가 있어 playground에 ? 추가
      // if(loutePath == '/playground'){
      // 	loutePath = loutePath + '?'
      // }
      // for (let i = 0; i < this.menus.length; i++) {
      // 	// if(this.menus[i].children && this.menus[i].children.length > 0){
      // 	// 	for (let j = 0; j < this.menus[i].children.length; j++) {
      // 	// 		const path = this.menus[i].children[j].path;
      // 	// 		if(path.includes(loutePath)){
      // 	// 			this.menus[i].isActive = true;
      // 	// 			return;
      // 	// 		}
      // 	// 	}
      // 	// } else {
      // 	// 	const path = this.menus[i].path;
      // 	// 	if(path.includes(loutePath)){
      // 	// 		this.menus[i].isActive = true;
      // 	// 		return;
      // 	// 	}
      // 	// }
      // 	this.menus[i].isActive = false;
      // 	this.isSubHeaderOver = false;
      // }
    },
    blankFunc(e) {
      console.log(e);
    },
    clickMoveFAQ() {
      window.open(
        `${process.env.VUE_APP_GACHI_MALL_HOST}/mn/cm/mncm005?faqTypCd=900`
      );
    },
    clickSameRoute(path) {
      if (path.indexOf("?") > -1) {
        path = path.substring(0, path.indexOf("?"));
      }
      if (path === this.$route.path) {
        if (path === "/studio") {
          this.$router.push("/studio");
        }
        this.$router.go(0);
      }
    },
    onClickScrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    asideOpen() {
      // 메뉴 열기
      this.openAsideMenu(true);
    },
    activeMenus() {
      // console.log('activeMenus');
      let routePath = this.$route.path;
      // playground 와 playground2 가 있어 playground에 ? 추가
      if (routePath == "/playground") {
        routePath = routePath + "?";
      }

      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].children && this.menus[i].children.length > 0) {
          let childPathActive = false;
          for (let j = 0; j < this.menus[i].children.length; j++) {
            const path = this.menus[i].children[j].path;
            if (path.includes(routePath)) {
              childPathActive = true;
            }
          }
          if (childPathActive) {
            this.menus[i].isActive = true;
          } else {
            this.menus[i].isActive = false;
          }
        } else {
          const path = this.menus[i].path;

          if (path.includes(routePath)) {
            this.menus[i].isActive = true;
          } else {
            this.menus[i].isActive = false;
          }
        }
      }
      if (routePath === "/" || routePath === "/en") {
        for (let i = 0; i < this.menus.length; i++) {
          this.menus[i].isActive = false;
        }
        return;
      }
    },
    clickMoveFANFANAgent() {
      if (
        typeof this.session == "undefined" ||
        typeof this.session.userId === "undefined"
      ) {
        this.$router.push({ name: "Login" });
      } else if (this.session.userPattnCd === "400") {
        //const path = this.isMobile ? '/RequestConnect.jsp?RelayState=/mobile/main.do' : '/RequestConnect.jsp?RelayState=/portal/main.do';
        const path =
          "/RequestConnect.jsp?RelayState=https://fanfandaero.kr/portal/main.do";
        const url = `${process.env.VUE_APP_FANFAN_SSO_AGENT_HOST}` + path;

        window.location = url;
      } else {
        window.location = "https://fanfandaero.kr/";
      }
    },
  },
};
</script>
